import React from 'react';
import { Typography, Box, GRAY } from '@applyboard/ui-components';
import { MinimumMarks } from "./MinimumMarks";
import { DuolingoMinimumMarks } from "./DuolingoMinimumMarks";
import { TOEFL_NOT_REQUIRED_BAND_SCORE, IELTS_NOT_REQUIRED_BAND_SCORE, PTE_NOT_REQUIRED_BAND_SCORE } from "./constants";
export var MinimumLanguageTestScores = function MinimumLanguageTestScores(_ref) {
  var marks = _ref.marks;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    mt: 5,
    mb: 3,
    style: {
      color: GRAY[10]
    }
  }, "Minimum Language Test Scores"), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(MinimumMarks, {
    title: "IELTS",
    average: marks.minIeltsAverage,
    listening: marks.minIeltsListening,
    reading: marks.minIeltsReading,
    speaking: marks.minIeltsSpeaking,
    writing: marks.minIeltsWriting,
    requiredMinimumMark: IELTS_NOT_REQUIRED_BAND_SCORE
  }), /*#__PURE__*/React.createElement(MinimumMarks, {
    title: "TOEFL",
    average: marks.minToeflTotal,
    listening: marks.minToeflListening,
    reading: marks.minToeflReading,
    speaking: marks.minToeflSpeaking,
    writing: marks.minToeflWriting,
    requiredMinimumMark: TOEFL_NOT_REQUIRED_BAND_SCORE
  }), /*#__PURE__*/React.createElement(MinimumMarks, {
    title: "PTE",
    average: marks.minPteOverall,
    listening: marks.minPteListening,
    reading: marks.minPteReading,
    speaking: marks.minPteSpeaking,
    writing: marks.minPteWriting,
    requiredMinimumMark: PTE_NOT_REQUIRED_BAND_SCORE
  }), /*#__PURE__*/React.createElement(DuolingoMinimumMarks, {
    minScore: marks.minDuolingoScore,
    comprehensionScore: marks.minDuolingoComprehensionScore,
    productionScore: marks.minDuolingoProductionScore,
    conversationScore: marks.minDuolingoConversationScore,
    literacyScore: marks.minDuolingoLiteracyScore
  })));
};